import { client } from "api";

export type GetOrderStatsResponse = Array<{ companyId: string; companyName: string; totalOrders: number; ordersLastYear: number; ueCode: string }>;

export const getOrderStats = () =>
  client.get<GetOrderStatsResponse>(`/company/order-stats`).then((res) => res.data);
